import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-enamad',
  templateUrl: './enamad.component.html',
  styleUrls: ['./enamad.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EnamadComponent implements OnInit {

  rand: number;
  @Input() enamad = false;
  @Input() samandehi = false;
  @Input() licence = true;
  show: boolean;

  constructor(private sharedService: SharedService) {
    this.rand = Math.random();
  }

  ngOnInit(): void {
    if (!this.sharedService.isBrowser) return;
    this.show = true;
  }

}
